const Shimmer = ()=>{
  return (
  <div className="shimmer-container">
    <div className="shimmer-cards"></div>
    <div className="shimmer-cards"></div>
    <div className="shimmer-cards"> </div>
    <div className="shimmer-cards"></div>
    <div className="shimmer-cards"></div>
    <div className="shimmer-cards"> </div>
    <div className="shimmer-cards"></div>
    <div className="shimmer-cards"></div>
    <div className="shimmer-cards"> </div>
    <div className="shimmer-cards"></div>
    <div className="shimmer-cards"></div>
    <div className="shimmer-cards"> </div>
    <div className="shimmer-cards"> </div>
    <div className="shimmer-cards"></div>
    <div className="shimmer-cards"></div>
    <div className="shimmer-cards"> </div>
    <div className="shimmer-cards"> </div>
    <div className="shimmer-cards"></div>
    <div className="shimmer-cards"></div>
    <div className="shimmer-cards"> </div>
    
  </div>
  );
}
export default Shimmer;